import styled from '@emotion/styled';

export const Logo = styled.img`
  float: left;
  max-width: 10rem;
  margin: 0.75rem;
`;
